import { format, parseISO, isValid } from "date-fns";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FormControl, FormHelperText } from "@mui/material";

export const CustomDatePicker = ({
  label = "",
  size = "small",
  name = "",
  value = "",
  onChange,
  minDate,
  maxDate,
  error = "",
  helperText = "",
  formatString = "yyyy-MM-dd",
  disabled = false,
}) => {
  const handleChange = (value) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: isValid(value) ? format(value, formatString) : "",
        },
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormControl
        fullWidth
        size={size}
        error={!!error}
        disabled={disabled}
        sx={{ mt: 2 }}
      >
        <DatePicker
          label={label}
          name={name}
          value={value ? parseISO(value) : null}
          onChange={handleChange}
          minDate={minDate}
          maxDate={maxDate}
          format="dd/MM/yyyy"
          disabled={disabled}
          slotProps={{
            textField: {
              size,
              fullWidth: true,
              error: !!error,
            },
          }}
        />
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
        {!!error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  );
};
